module.exports = __webpack_public_path__ + "static/img/op-title.3600fd6a.png";